import Vue from 'vue';
import store from '../../store';
import paymentMethodTransformer from '../../transformers/paymentMethod';

const success = ({ data }, resolve) => {
  const paymentMethods = paymentMethodTransformer.fetchCollection(data.data);

  store.dispatch('fetchPaymentMethods', paymentMethods);
  resolve();
};

const failed = () => {
};

export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('payment_methods')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/paymentMethods/all.js